import { useMemo } from 'react';
import { useAuth } from '@/auth/authContext';

/**
 * Returns a function to check if the current user has a specific permission by name.
 * Uses the same permission name strings as defined in permissions.ts (e.g., "Edit Countries").
 */
export function usePermissionCheck() {
  const { user } = useAuth();

  const userPermissions = useMemo(() => {
    if (!user) return new Set<string>();

    // Super admin has all permissions
    const role = (user.role || '').replace(/^ROLE_/, '').toLowerCase();
    const roles = (user.roles ?? []).map((r: any) => String(r).replace(/^ROLE_/, '').toLowerCase());
    if (role === 'super_admin' || roles.includes('super_admin')) {
      return 'ALL' as const;
    }

    const perms = (user.permissions ?? [])
      .map((p: any) => typeof p === 'string' ? p : p.name || '')
      .filter(Boolean);
    return new Set(perms);
  }, [user]);

  return (permissionName: string): boolean => {
    if (userPermissions === 'ALL') return true;
    return userPermissions.has(permissionName);
  };
}
